import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import PROJECTS_DATA from "../projects.data";

const initialState = {
    projects: PROJECTS_DATA,
    counter: 0,
}

const projectReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

const store = createStore(projectReducer, composeWithDevTools())

export default store